import {css} from '@emotion/css';

const styles = {
  plusMinusExpand: (isOpen?: boolean): string => css`
    label: plusMinusExpand;

    .plusMinus__vertical {
      transform-origin: center center;
      transform: scaleY(0);
      transition: transform 250ms;
      ${isOpen ? '' : 'transform: scaleY(1);'}
    }
  `,
};

export default styles;
